<script>
import numeral from 'numeral'

export default {
  functional: true,

  props: {
    total: {
      type: Number,
      default: 0
    }
  },

  render(h, { data, props }) {
    return (
      <div {...data}>
        <el-row
          type="flex"
          gutter={16}
          style={{ flexWrap: 'wrap', fontSize: '1.25rem', fontWeight: 'bold' }}
        >
          <el-col span={null} xs={24} style={{ flex: '1' }}>
            รวม (บาท)
          </el-col>
          <el-col span={null} xs={24} style={{ textAlign: 'right' }}>
            {numeral(props.total).format('0,0.00')}
          </el-col>
        </el-row>
      </div>
    )
  }
}
</script>
